// extracted by mini-css-extract-plugin
export default {"base":"HeaderLinks_base__qr14h"};